import React, { useEffect } from 'react';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import { TextsProvider } from './components/TextsContext';
import AlponaBackground from './components/AlponaBackground';
import Hero from './components/Hero';
import Flipbook from './components/Flipbook';
import Marquee from './components/Marquee';
import Details from './components/Details';
import Footer from './components/Footer';
import MusicToggle from './components/MusicToggle';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center font-display text-3xl text-kula-red">
          শুভ বিবাহ
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen overflow-x-clip">
        <AlponaBackground />
        <div className="grain" />
        <main className="relative z-10">
          <TextsProvider>
          <div className="px-12 md:px-24">
            <Hero />
            <Flipbook />
            <Details />
            <Footer />
          </div>
          </TextsProvider>
          <Marquee />
        </main>
        <MusicToggle />
        <Toaster position="top-center" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
